function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { defineComponent, onMounted, ref, watch, computed, reactive, nextTick, getCurrentInstance } from "vue";
import UserJourney from "@com/components/user-journey/index.vue";
import { resolveUserJourneyData, GraphMode } from "@com/components/user-journey/utils";
export default defineComponent({
    components: {
        UserJourney: UserJourney
    },
    props: {
        visible: {
            type: Boolean
        },
        actions: {
            type: Object
        },
        type: {
            // action: 埋点名称，journey用户旅程
            type: String
        },
        panes: {
            type: Array,
            default: function() {
                return [
                    "actions",
                    "journey"
                ];
            }
        },
        journeyData: {
            type: Object
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var dialogVisible = ref(false);
        var userJourneyRef = ref();
        var formRef = ref();
        var dialogTitle = computed(function() {
            return props.type === "actions" ? "\u8BBE\u7F6E\u57CB\u70B9\u540D\u79F0" : "\u914D\u7F6E\u7528\u6237\u65C5\u7A0B";
        });
        var actionModel = reactive({
            action1: "",
            action2: "",
            action3: "",
            action4: "",
            action5: "",
            action6: "",
            action7: "",
            action8: "",
            action9: "",
            action10: "",
            action11: "",
            action12: "",
            action13: "",
            action14: "",
            action15: ""
        });
        var journeyData = ref();
        onMounted(function() {});
        var validateActionName = function(rule, value, callback) {
            if (value.length === 0) {
                callback();
            } else if (value.length > 100) {
                callback(new Error("\u540D\u79F0\u4E0D\u80FD\u8D85\u8FC7100\u4E2A\u5B57\u7B26"));
            }
            callback();
        };
        var initData = function(data) {
            Object.keys(actionModel).forEach(function(key) {
                if (key) {
                    actionModel[key] = data[key] && data[key]["zh-cn"] ? data[key]["zh-cn"] : "";
                }
            });
        };
        var getCurrentActionsData = function(_actionModel) {
            var data = _objectSpread({}, _actionModel || actionModel);
            for(var key in data){
                if (!data[key]) {
                    delete data[key];
                } else {
                    data[key] = {
                        "zh-cn": data[key],
                        en: data[key]
                    };
                }
            }
            return data;
        };
        var actionSchema = computed(function() {
            var schema = {
                type: "object",
                properties: {}
            };
            var keys = Object.keys(actionModel);
            for(var i = 0; i < keys.length; i++){
                var key = keys[i];
                if (key) {
                    schema.properties[key] = {
                        label: key,
                        component: "input",
                        field: {
                            placeholder: "\u8BF7\u8F93\u5165".concat(key, "\u540D\u79F0")
                        },
                        rules: [
                            {
                                validator: validateActionName,
                                trigger: "blur"
                            }, 
                        ]
                    };
                }
            }
            return schema;
        });
        var innerJourneyData = computed(function() {
            var tempActions = getCurrentActionsData(actionModel);
            for(var key in tempActions){
                tempActions[key] = tempActions[key]["zh-cn"];
            }
            var temp = _objectSpreadProps(_objectSpread({}, props.journeyData), {
                actionNameDictionary: tempActions
            });
            if (journeyData.value) {
                temp.user_journeys = journeyData.value;
            }
            return temp;
        });
        var getCurrentJourney = function() {
            var _$ref;
            var data = (_$ref = userJourneyRef.value) === null || _$ref === void 0 ? void 0 : _$ref.getEdges();
            return data.map(function(edge) {
                return {
                    pre_action: edge.source,
                    action: edge.target
                };
            });
        };
        var handleSubmit = function() {
            var data = {};
            if (props.panes.indexOf("actions") !== -1) {
                if (formRef.value && !formRef.value.validate()) {
                    return;
                }
                data.actions = getCurrentActionsData();
            }
            if (props.panes.indexOf("journey") !== -1) {
                if (userJourneyRef.value && !userJourneyRef.value.validate()) {
                    return;
                }
                data.journey = getCurrentJourney();
            }
            emit("submit", data);
            dialogVisible.value = false;
        };
        var updateJourneyView = function() {
            // 添加少量延迟，避免旅程触发时机导致展示异常
            setTimeout(function() {
                var _$ref;
                (_$ref = userJourneyRef.value) === null || _$ref === void 0 ? void 0 : _$ref.changeData(resolveUserJourneyData(innerJourneyData.value));
            }, 100);
        };
        var handleClick = function(name) {
            emit("updateTab", name);
            if (name === "journey") {
                nextTick(function() {
                    setTimeout(function() {
                        updateJourneyView();
                    }, 0);
                });
            }
        };
        var handleBeforeLeave = function(activeName, oldActiveName) {
            // 校验actions
            if (oldActiveName === "actions") {
                if (formRef.value) {
                    var res = formRef.value.validate();
                    res.catch(function() {
                        root.$message({
                            message: "\u5305\u542B\u65E0\u6548\u5185\u5BB9\uFF0C\u8BF7\u4FEE\u6539\u540E\u518D\u5C1D\u8BD5\u64CD\u4F5C",
                            type: "error"
                        });
                    });
                    return res;
                }
            }
            // 校验journey
            if (oldActiveName === "journey") {
                if (userJourneyRef.value && userJourneyRef.value.validate()) {
                    journeyData.value = getCurrentJourney();
                    return true;
                }
                root.$message({
                    message: "\u5305\u542B\u65E0\u6548\u5185\u5BB9\uFF0C\u8BF7\u4FEE\u6539\u540E\u518D\u5C1D\u8BD5\u64CD\u4F5C",
                    type: "error"
                });
                return false;
            }
            return true;
        };
        watch(function() {
            return props.visible;
        }, function(val) {
            dialogVisible.value = props.visible;
            if (props.visible) {
                nextTick(function() {
                    initData(props.actions);
                    journeyData.value = null;
                    updateJourneyView();
                });
            }
        });
        watch(function() {
            return dialogVisible.value;
        }, function(val) {
            emit("update:visible", val);
        });
        return {
            userJourneyRef: userJourneyRef,
            formRef: formRef,
            GraphMode: GraphMode,
            dialogVisible: dialogVisible,
            actionSchema: actionSchema,
            actionModel: actionModel,
            dialogTitle: dialogTitle,
            handleSubmit: handleSubmit,
            handleClick: handleClick,
            handleBeforeLeave: handleBeforeLeave
        };
    }
});
